<template>
  <div
    class="record-detail"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.4)"
  >
    <el-page-header @back="goBack">
      <template slot="content">
        <span
          style="font-size: 18px;color: #303133;line-height: 24px; font-weight: bolder"
          >参数集详情</span
        >
      </template>
    </el-page-header>
    <div ref="page">
      <el-scrollbar style="height: 100%">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title">
              <span style="font-size: 16px; font-weight: bolder"
                ><i class="el-icon-cold-drink"></i>基本信息</span
              >
            </template>
            <el-card>
              <p><strong>名称&nbsp;:</strong>&nbsp;&nbsp;{{ record.name }}</p>
              <p>
                <strong>功能说明(英)&nbsp;:</strong>&nbsp;&nbsp;{{
                  record.describe
                }}
              </p>
              <p>
                <strong>功能说明(中)&nbsp;:</strong>&nbsp;&nbsp;
                <el-input
                  style="width: 300px"
                  size="mini"
                  v-model="record.chineseDescribe"
                  placeholder="请输入内容"
                ></el-input
                >&nbsp;&nbsp;
                <el-button type="text" @click="updateDescribe">修改</el-button>
              </p>
              <p>
                <strong>参数个数&nbsp;:</strong>&nbsp;&nbsp;{{
                  record.paramCount
                }}
              </p>
            </el-card>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <span style="font-size: 16px; font-weight: bolder"
                ><i class="el-icon-grape"></i>详情信息</span
              >
            </template>
            <el-row :gutter="10">
              <el-col :span="12">
                <!-- :autosize="{ minRows: 2, maxRows: 16}" -->
                <h5>英文</h5>
                <el-input
                  type="textarea"
                  autosize
                  v-model="record.helpText"
                  :readonly="true"
                ></el-input>
              </el-col>
              <el-col :span="12">
                <h5>中文</h5>
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 50 }"
                  v-model="record.chineseHelpText"
                  placeholder="请输入内容"
                ></el-input>
                <el-button
                  style="margin-top: 20px"
                  plain
                  size="small"
                  @click="updateHelpText"
                  >修改</el-button
                >
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template slot="title">
              <span style="font-size: 16px; font-weight: bolder"
                ><i class="el-icon-coffee"></i>参数列表</span
              >
            </template>
            <el-table :data="parameterList" style="width: 100%">
              <el-table-column type="expand" label="可选项" width="80">
                <template slot-scope="scope">
                  <el-card v-if="scope.row.selected === 1">
                    <!-- TODO: 选项UI -->
                    <el-button
                      size="mini"
                      @click="openOptionDialog(scope.row.id, null)"
                      >添加选项</el-button
                    >
                    <el-table :data="scope.row.optionsList" style="width: 100%">
                      <el-table-column
                        prop="name"
                        label="选项名"
                        width="100"
                      ></el-table-column>
                      <el-table-column
                        prop="value"
                        label="选项值"
                        width="70"
                      ></el-table-column>
                      <el-table-column
                        prop="info"
                        label="英文说明"
                        width="500"
                      ></el-table-column>
                      <el-table-column
                        prop="chineseInfo"
                        label="中文说明"
                      ></el-table-column>
                      <el-table-column
                        fixed="right"
                        align="center"
                        label="操作"
                      >
                        <template slot-scope="options">
                          <el-button
                            type="text"
                            size="small"
                            @click="openOptionDialog(null, options.row)"
                            >编辑</el-button
                          >
                          <el-button
                            type="text"
                            size="small"
                            @click="
                              deleteOptionsById(options.row.id, options.row.pid)
                            "
                            >删除</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-card>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="name"
                label="英文名称"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="chineseName"
                label="中文名称"
              ></el-table-column>
              <el-table-column
                align="left"
                prop="describe"
                label="功能说明(英)"
                width="350"
              ></el-table-column>
              <el-table-column
                align="left"
                prop="chineseDescribe"
                label="功能说明(中)"
                width="200"
              ></el-table-column>
              <el-table-column align="center" label="输入特性">
                <template slot-scope="scope">
                  <el-tag
                    effect="dark"
                    type="danger"
                    v-if="scope.row.required === 1"
                    >用户输入</el-tag
                  >
                  <el-tag effect="dark" type="info" v-else>建议默认</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="是否可选">
                <template slot-scope="scope">
                  <el-tag effect="dark" v-if="scope.row.selected === 1"
                    >可选</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="defaultValue"
                label="默认值"
              ></el-table-column>
              <el-table-column align="center" label="单位">
                <template slot-scope="scope">
                  <span v-if="scope.row.unit === null">-</span>
                  <span v-else>{{ scope.row.unit }}</span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                align="center"
                label="操作"
                width="80"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="openParamDialog(scope.row)"
                    >编辑</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </el-scrollbar>
    </div>
    <!-- 参数添加/修改窗口 -->
    <el-dialog
      width="400px"
      :title="paramDialogTitle"
      :visible.sync="paramDialogVisible"
      :before-close="closeParamDialog"
    >
      <el-form :inline="true" :model="paramFormData" ref="paramFormRef">
        <el-form-item label="英文名称" prop="name">
          <el-input v-model="paramFormData.name" size="small"></el-input>
        </el-form-item>
        <el-form-item label="中文名称" prop="chineseName">
          <el-input v-model="paramFormData.chineseName" size="small"></el-input>
        </el-form-item>
        <el-form-item label="英文说明" prop="describe">
          <el-input v-model="paramFormData.describe" size="small"></el-input>
        </el-form-item>
        <el-form-item label="中文说明" prop="chineseDescribe">
          <el-input
            v-model="paramFormData.chineseDescribe"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="默认值" prop="defaultValue">
          <el-input
            v-model="paramFormData.defaultValue"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="输入特性" prop="required">
          <el-switch
            v-model="paramFormData.required"
            :active-value="1"
            :inactive-value="0"
            active-text="用户输入"
            inactive-text="建议默认"
          ></el-switch>
        </el-form-item>
        <el-form-item label="是否可选" prop="selected">
          <el-switch
            v-model="paramFormData.selected"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeParamDialog">取 消</el-button>
        <el-button type="primary" @click="submitParamForm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 选项添加/修改窗口 -->
    <el-dialog
      width="400px"
      :title="optionDialogTitle"
      :visible.sync="optionDialogVisible"
      :before-close="closeOptionDialog"
    >
      <el-form :inline="true" :model="optionFormData" ref="optionFormRef">
        <el-form-item label="选项名称" prop="name">
          <el-input v-model="optionFormData.name"></el-input>
        </el-form-item>
        <el-form-item label="选  项  值" prop="value">
          <!-- <el-input-number v-model="optionFormData.value" :min="-100" :max="100"></el-input-number> -->
          <el-input v-model="optionFormData.value"></el-input>
        </el-form-item>
        <el-form-item label="英文说明" prop="info">
          <el-input
            v-model="optionFormData.info"
            type="textarea"
            :rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item label="中文说明" prop="chinese_info">
          <el-input
            v-model="optionFormData.chineseInfo"
            type="textarea"
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeOptionDialog">取 消</el-button>
        <el-button type="primary" @click="submitOptionForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * Record(
 * id=2,
 * arrayIndex=1,
 * name=Rec 1,
 * chineseName=null,
 * describe=Program Mode and Output Control,
 * chineseDescribe=null,
 * helpText=null,
 * chineseHelpText=null,
 * dataType=0,
 * paramCount=14,
 * used=1)
 */
import router from "@/router";
export default {
  data() {
    return {
      record: {
        id: null,
        arrayIndex: null,
        name: null,
        chineseName: null,
        describe: null,
        chineseDescribe: null,
        helpText: null,
        chineseHelpText: null,
        dataType: null,
        paramCount: null,
        used: 1
      },
      parameterList: [],
      paramDialogTitle: "",
      paramDialogVisible: false,
      paramFormData: {
        id: null,
        name: "",
        chineseName: "",
        describe: "",
        chineseDescribe: "",
        defaultValue: "",
        required: 0,
        selected: 0
      },
      optionDialogTitle: "",
      optionDialogVisible: false,
      optionFormData: {
        id: null,
        pid: null,
        name: "",
        value: "",
        info: "",
        chineseInfo: ""
      },
      loading: false,
      activeNames: ["1"]
    };
  },
  mounted() {
    this.setHeight();
  },
  created() {
    this.loadData();
  },
  methods: {
    // 加载数据
    loadData() {
      this.loading = true;
      const rid = this.$route.query.id;
      this.axios
        .all([
          this.axios.get(`/record/${rid}`),
          this.axios.get("/parameters", { params: { rid: rid } })
        ])
        .then(
          this.axios.spread((res1, res2) => {
            this.record = res1.data;
            this.parameterList = res2.data;
            this.loading = false;
          })
        );
    },
    // 保存选项后局部加载数据
    loadOptionsByParam(pid) {
      this.axios.get("/options", { params: { pid: pid } }).then(res => {
        this.parameterList.map(p => {
          if (p.id === pid) {
            p.optionsList = res.data;
          }
        });
      });
    },
    // 返回参数集列表页
    goBack() {
      router.go(-1);
    },
    // 更新中文功能说明
    updateDescribe() {
      this.$confirm(`${this.record.chineseDescribe}`, "修改中文功能说明", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      })
        .then(() => {
          this.axios
            .patch("/record/describe", {
              id: this.record.id,
              chineseDescribe: this.record.chineseDescribe
            })
            .then(res => {
              this.$message({
                type: "success",
                message: "修改成功!"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 更新中文帮助文档
    updateHelpText() {
      this.$confirm("确定提交中文帮助文档", "修改中文帮助文档", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      })
        .then(() => {
          this.axios
            .patch("/record/helpText", {
              id: this.record.id,
              chineseHelpText: this.record.chineseHelpText
            })
            .then(res => {
              this.$message({
                type: "success",
                message: "修改成功!"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // -------------------参数-------------------------
    openParamDialog(parameters) {
      this.paramFormData = {
        id: parameters.id,
        name: parameters.name,
        chineseName: parameters.chineseName,
        describe: parameters.describe,
        chineseDescribe: parameters.chineseDescribe,
        defaultValue: parameters.defaultValue,
        required: parameters.required,
        selected: parameters.selected
      };
      this.paramDialogTitle = "编辑参数";
      this.paramDialogVisible = true;
    },
    closeParamDialog() {
      this.paramDialogTitle = "";
      this.paramDialogVisible = false;
      this.resetParamForm();
    },
    submitParamForm() {
      this.$refs.paramFormRef.validate(valid => {
        if (valid) {
          this.updateParam();
        } else {
          return false;
        }
      });
    },
    resetParamForm() {
      this.paramFormData = {
        id: null,
        name: "",
        chineseName: "",
        describe: "",
        chineseDescribe: "",
        defaultValue: "",
        required: 0,
        selected: 0
      };
      this.$refs.paramFormRef.resetFields();
    },
    updateParam() {
      this.axios
        .patch("/parameters", {
          id: this.paramFormData.id,
          name: this.paramFormData.name,
          chineseName: this.paramFormData.chineseName,
          describe: this.paramFormData.describe,
          chineseDescribe: this.paramFormData.chineseDescribe,
          defaultValue: this.paramFormData.defaultValue,
          required: this.paramFormData.required,
          selected: this.paramFormData.selected
        })
        .then(res => {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.loadData();
          this.closeParamDialog();
        });
    },
    // --------------------选项---------------------
    openOptionDialog(pid, option) {
      if (option === null) {
        this.optionFormData = {
          id: null,
          pid: pid,
          name: "",
          value: "",
          info: "",
          chineseInfo: ""
        };
        this.optionDialogTitle = "添加选项";
      } else {
        this.optionFormData = {
          id: option.id,
          pid: option.pid,
          name: option.name,
          value: option.value,
          info: option.info,
          chineseInfo: option.chineseInfo
        };
        this.optionDialogTitle = "编辑选项";
      }
      this.optionDialogVisible = true;
    },
    closeOptionDialog() {
      this.optionDialogTitle = "";
      this.optionDialogVisible = false;
      this.resetOptionForm();
    },
    submitOptionForm() {
      this.$refs.optionFormRef.validate(valid => {
        if (valid) {
          this.saveOrUpdateOption();
        } else {
          return false;
        }
      });
    },
    resetOptionForm() {
      this.optionFormData = {
        id: null,
        pid: null,
        name: "",
        value: "",
        info: "",
        chineseInfo: ""
      };
      this.$refs.optionFormRef.resetFields();
    },
    saveOrUpdateOption() {
      this.axios.post("/options", this.optionFormData).then(res => {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.loadOptionsByParam(this.optionFormData.pid);
        this.closeOptionDialog();
      });
    },
    deleteOptionsById(id, pid) {
      this.$confirm("是否删除该选项?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.axios.delete(`/options/${id}`).then(res => {
          this.$message({
            message: "删除成功!",
            type: "success"
          });
          this.loadOptionsByParam(pid);
        });
      });
    },
    setHeight() {
      const clientHeight =
        document.documentElement.clientHeight - 60 - 50 - 40 - 24;
      this.$refs.page.style.height = clientHeight + "px";
    }
  }
};
</script>

<style lang="less" scoped>
.record-detail {
  height: 100%;
}
.form-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
